// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"ea806bca","754":"96158d2a"}[chunkId] + ".chunk.js";
};